import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading">
      <img src="/images/Loading.png" alt="loading" />
    </div>
  );
};

export default Loading;
